
(function() {

    const getIsPc = () => {
        const userAgentInfo = navigator.userAgent;
        const Agents = [
            "Android",
            "iPhone",
            "SymbianOS",
            "Windows Phone",
            "iPad",
            "iPod",
        ];
        let flag = true;
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
            }
        }
        return flag;
    };

    function findEleByClass(ele, className) {
        if (ele === document.body || !ele) return null
        if (ele.className.indexOf?.(className) >= 0) return ele
        return findEleByClass(ele.parentElement, className)
    }

    function handleColorListMouseMove(ele) {
        let isMouseDown = false
        let lastPageX = null
        const moveEle = ele.querySelector('.product-item-meta__swatch-list')
        const parentEle = moveEle.parentElement
        const eleForArrow = parentEle.parentElement

        const getScrollWidth = () => {
            if (!eleForArrow.hasAttribute('data-bundle-swatch-list')) {
                return (moveEle.children?.length ?? 0) * 24
            }

            const styles = getComputedStyle(moveEle)
            const children = [...moveEle.children]
            const gap = parseFloat(styles.columnGap) || 0
            return children.reduce((width, child) => width + child.offsetWidth, 0)
                + Math.max(0, children.length - 1) * gap
                + (parseFloat(styles.paddingLeft) || 0)
                + (parseFloat(styles.paddingRight) || 0)
        }
        let scrollWidth = getScrollWidth()
        let maxDiff = parentEle.offsetWidth - scrollWidth
        let translateX = 0
        let ancestor = findEleByClass(ele,'product-item-meta__swatch-list-container')
        let isPC = getIsPc()
        
        function handleMouseDown(e) {
            e.stopPropagation()
            isMouseDown = true
            lastPageX = isPC ? e.pageX : e.touches[0]?.pageX
        }
        
        function handleMouseUp(e) {
            e.stopPropagation()
            isMouseDown = false
            lastPageX = null
        }
        
        function handleMouseMove(e) {
            if (!isMouseDown || lastPageX === null) return
            e.stopPropagation()
            const curPageX = isPC ? e.pageX : e.touches[0]?.pageX
            const diff = lastPageX - curPageX
            translateX = Math.max(Math.min(0, translateX - diff), maxDiff)
            moveEle.style.transform = `translateX(${translateX}px)`
            lastPageX = curPageX
            updateStatusOfArrow(eleForArrow, translateX)
        }
        
        
        function initArrow (ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            leftArrow.className += ' disabled'
            leftArrow.className = leftArrow.className.replace('hidden', '')
            rightArrow.className = rightArrow.className.replace('hidden', '')
            setTimeout(function() {
                scrollWidth = getScrollWidth()
                maxDiff = parentEle.offsetWidth - scrollWidth
            }, 10);

            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            leftArrow.addEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
            rightArrow.addEventListener('click', handleArrowClick('right', ele))
        }

        function recoverArrow(ele) {
            if (!ele) return
            if (![...ele.children]?.some((child) => child.className.indexOf('arrow') >= 0)) {
                return
            }

            const leftArrow = ele.querySelector('.arrow.left'), rightArrow = ele.querySelector('.arrow.right')
            if (leftArrow.className.indexOf('hidden') < 0) {
                leftArrow.className += ' hidden'
            }
            if (rightArrow.className.indexOf('hidden') < 0) {
                rightArrow.className += ' hidden'
            }
            leftArrow.removeEventListener('click', handleArrowClick('left', ele))
            rightArrow.removeEventListener('click', handleArrowClick('right', ele))
        }
        
        function updateStatusOfArrow(parentEle, translateX) {
            if (!parentEle) return
            const leftArrowDom = parentEle.querySelector('.arrow.left'), rightArrowDom = parentEle.querySelector('.arrow.right')
            if (translateX <= maxDiff) {
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.className = leftArrowDom.className.replace('disabled', '')
                }
                if (rightArrowDom.className.indexOf('disabled') >= 0) return
                rightArrowDom.className += ' disabled'
            } else if (translateX === 0) {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.className = rightArrowDom.className.replace('disabled', '')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) return
                leftArrowDom.className += ' disabled'
            } else {
                if (rightArrowDom.className.indexOf('disabled') >= 0) {
                    rightArrowDom.className = rightArrowDom.className.replace('disabled', '')
                }
                if (leftArrowDom.className.indexOf('disabled') >= 0) {
                    leftArrowDom.className = leftArrowDom.className.replace('disabled', '')
                }
            }
        }
        
        function handleArrowClick(direction, parentEle) {
            return function (e) {
                const moveEleWidth = moveEle.offsetWidth, isLeftBtn = direction === 'left'
                translateX = translateX + (!isLeftBtn ? -moveEleWidth : moveEleWidth)
                translateX = Math.max(Math.min(0, translateX), maxDiff)
                moveEle.style.transform = `translateX(${translateX}px)`
                updateStatusOfArrow(eleForArrow, translateX)
            }
        }
        
        function handleMouseScroll() {
            if (parentEle.scrollLeft > 0) {
                parentEle.scrollLeft = 0
            }
        }
        
        if (ele && maxDiff < 0) {
            initArrow(eleForArrow)
            moveEle.style.justifyContent = 'flex-start'

            // parentEle.removeEventListener('scroll', handleMouseScroll)
            // parentEle.addEventListener('scroll', handleMouseScroll)
            if (isPC) {
                ele.removeEventListener('mousedown', handleMouseDown)
                ele.removeEventListener('mousemove', handleMouseMove)
                ele.removeEventListener('mouseup', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)
                
                ele.addEventListener('mousedown', handleMouseDown)
                ele.addEventListener('mousemove', handleMouseMove)
                ele.addEventListener('mouseup', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            } else {
                ele.removeEventListener('touchstart', handleMouseDown)
                ele.removeEventListener('touchmove', handleMouseMove)
                ele.removeEventListener('touchend', handleMouseUp)
                ancestor.removeEventListener('mouseleave', handleMouseUp)
                
                ele.addEventListener('touchstart', handleMouseDown)
                ele.addEventListener('touchmove', handleMouseMove)
                ele.addEventListener('touchend', handleMouseUp)
                ancestor.addEventListener('mouseleave', handleMouseUp)
            }
        } else {
            recoverArrow(eleForArrow)
        }
        
    }

    function addEventsToList(refresh) {
        const paginationDom = document.querySelector('.pagination__nav')
        if (paginationDom) {
            if (paginationDom === lastPaginationDom && !refresh) return false
            lastPaginationDom = paginationDom
            paginationDom.removeEventListener('click', handlePaginationClick)
            paginationDom.addEventListener('click', handlePaginationClick)
        }

        const productItems = document.querySelectorAll('.product-item-meta__swatch-list-container')
        if (productItems.length) {
            [...productItems].forEach(handleColorListMouseMove)
            return true
        }
        return false
    }

    let tryCount = 0, tryTimer = null, lastPaginationDom = null
    const maxTryCount = 10

    function tryToAddEvents() {
        if (tryTimer) {
            clearTimeout(tryTimer)
        }
        if (tryCount >= maxTryCount) return
        tryTimer = setTimeout(() => {
            const isAdded = addEventsToList()
            if (!isAdded) {
                tryToAddEvents()
                tryCount++
            } else {
                tryCount = 0
            }
        }, 500)
    }

    function handlePaginationClick() {
        tryToAddEvents()
    }

    function initProductItems(refresh) {
        addEventsToList(refresh)
    }

    window.addEventListener('DOMContentLoaded',() => {
        initProductItems()
    })

    window.addEventListener('resize', () => {
        initProductItems(true)
    })

})()
